import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

export const DEFAULT_DRAWER_CONFIG = {
  activeKey: null,
  completenessPct: undefined,
  completenessHint: undefined,
  isAmbassador: false,
  showCompleteness: true
};

export const MobileAppNavContext = createContext({
  drawerOpen: false,
  openDrawer: () => {},
  closeDrawer: () => {},
  drawerConfig: DEFAULT_DRAWER_CONFIG,
  setDrawerConfig: () => {},
  resetDrawerConfig: () => {}
});

export const MobileAppNavProvider = ({ children }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerConfig, setDrawerConfigState] = useState(DEFAULT_DRAWER_CONFIG);

  const openDrawer = useCallback((config = {}) => {
    setDrawerConfigState(prev => ({ ...prev, ...config }));
    setDrawerOpen(true);
  }, []);

  const closeDrawer = useCallback(() => setDrawerOpen(false), []);

  const setDrawerConfig = useCallback(config => {
    setDrawerConfigState(prev => ({ ...prev, ...config }));
  }, []);

  /**
   * Drop page-specific overrides (completeness, active key) when the page that
   * set them goes away — otherwise e.g. Change password's showCompleteness:false
   * would keep hiding the completeness bar on browse for the rest of the session.
   */
  const resetDrawerConfig = useCallback(() => {
    setDrawerConfigState(DEFAULT_DRAWER_CONFIG);
  }, []);

  const value = useMemo(
    () => ({ drawerOpen, openDrawer, closeDrawer, drawerConfig, setDrawerConfig, resetDrawerConfig }),
    [drawerOpen, openDrawer, closeDrawer, drawerConfig, setDrawerConfig, resetDrawerConfig]
  );

  return (
    <MobileAppNavContext.Provider value={value}>
      {children}
    </MobileAppNavContext.Provider>
  );
};

export const useMobileAppNav = () => useContext(MobileAppNavContext);
